import { GridColDef, GridSortModel } from "@mui/x-data-grid";
import { ProductRequest } from "../../../models/product.models";
import CustomTable, { PaginationModel, TableRow } from "../../common/CustomTable";
import { useEffect, useState } from "react";
import { ClientDashboardText, DataGridText } from "../../../data/texts";
import ProductCell from "./ProductCell";
import { ImageService } from "../../../services/image.service";
import { Icons } from "../../../models/assets-files";
import { DateTimeService } from "../../../services/date-time.service";

interface ProductRequestTableProps {
  requests: ProductRequest;
  onSortColumn?: (model: GridSortModel) => void;
  page: number;
  onPagination: (model: PaginationModel) => void;
  onRowClick?: (params: any) => void;
}
export type ProductName = keyof typeof Icons.ProductRequestTable;
const ProductsTable = ({ requests, page, onPagination, onSortColumn, onRowClick }: ProductRequestTableProps) => {
  const [tableRows, setTableRows] = useState<TableRow[]>([]);
  const tableColumns: GridColDef[] = [
    {
      minWidth: 250,
      flex: 1,
      field: "productName",
      cellClassName: "productName",
      headerName: "Product Name",
      renderCell: (params) => {
        const productName = params.row.productName.toUpperCase().replace(" ", "_") as ProductName;
        const iconSrcName = Icons.ProductRequestTable[productName];
        return (
          <ProductCell
            text={params.row.productName}
            iconSrc={iconSrcName ? ImageService.getLocalIconPath(Icons.Folders.PRODUCT_REQUEST_TABLE, iconSrcName) : ""}
          />
        );
      },
    },
    {
      minWidth: 150,
      flex: 1,
      field: "date",
      headerName: "Date",
    },
    {
      minWidth: 150,
      flex: 1,
      field: "status",
      headerName: "Status",
    },
    {
      minWidth: 150,
      flex: 1,
      field: "amountDue",
      headerName: "Amount Due",
    },
  ];

  useEffect(() => {
    if (requests) {
      const rows: TableRow[] = [];

      if (requests.data && Array.isArray(requests.data)) {
        requests.data.forEach((request) => {
          rows.push({
            id: request.id,
            productName: request.productRequestType,
            date: DateTimeService.convertDateToDDMMYYYY(new Date(request.Created_Time)),
            status: request.status,
            amountDue: `${request.leftToPay ? `${(request.leftToPay || 0).toFixed(2)}` : ""}`,
          });
        });
      }
      setTableRows(rows);
    }
  }, [requests]);
  return (
    <CustomTable
      page={page}
      pageSize={7}
      onSortColumn={onSortColumn}
      title={ClientDashboardText.PRODUCT_REQUEST}
      totalRowNumber={requests.total || 0}
      onPaginationModelChange={onPagination}
      tableRows={tableRows}
      tableColumns={tableColumns}
      localeText={DataGridText.NO_REQUESTS}
      onRowClick={onRowClick}
    />
  );
};

export default ProductsTable;
